/** Maps GET /api/public/plans rows into the subscription compare UI model. */

function adaptPlanLimits(limits) {
  if (!limits || typeof limits !== 'object') {
    return { users: null, warehouses: null, products: null }
  }
  return {
    users: limits.users ?? null,
    warehouses: limits.warehouses ?? limits.locations ?? null,
    products: limits.products ?? null,
  }
}

const PLAN_ORDER = ['free', 'starter', 'growth', 'pro', 'enterprise']

export const ENTERPRISE_CATALOG_FALLBACK = {
  id: 'enterprise',
  kind: 'enterprise',
  code: 'enterprise',
  name: 'Enterprise',
  nameKey: 'subscription_plan_enterprise',
  priceMonthly: null,
  priceAnnual: null,
  priceLabelKey: 'subscription_price_call_sales',
  recommended: false,
  isEnterprise: true,
  limits: { users: null, warehouses: null, products: null },
  modules: [],
}

export function adaptPublicPlan(plan = {}) {
  const code = String(plan.code || '').toLowerCase()
  const customPricing = plan.custom_pricing === true
  const monthly = plan.monthly_price ?? null
  const annual = plan.annual_price ?? null

  return {
    id: code,
    kind: code,
    code,
    name: plan.name || code,
    nameKey: code ? `subscription_plan_${code}` : 'subscription_plan_kind_default',
    priceMonthly: customPricing ? null : monthly,
    priceAnnual: customPricing ? null : annual,
    priceLabelKey: customPricing ? 'subscription_price_call_sales' : code === 'free' && monthly === 0 ? 'subscription_price_forever' : null,
    recommended: plan.recommended === true,
    isEnterprise: customPricing,
    limits: adaptPlanLimits(plan.limits),
    modules: Array.isArray(plan.modules) ? plan.modules : [],
  }
}

export function ensureCatalogPlans(plans = []) {
  const list = [...plans]
  if (!list.some((plan) => plan.code === 'enterprise' || plan.kind === 'enterprise')) {
    list.push({ ...ENTERPRISE_CATALOG_FALLBACK })
  }
  return list.sort((left, right) => {
    const leftIndex = PLAN_ORDER.indexOf(left.code)
    const rightIndex = PLAN_ORDER.indexOf(right.code)
    return (leftIndex >= 0 ? leftIndex : 99) - (rightIndex >= 0 ? rightIndex : 99)
  })
}

export function adaptPublicPlansResponse(body = {}) {
  const rows = body?.data?.plans
  if (!Array.isArray(rows)) return []
  return ensureCatalogPlans(rows.map(adaptPublicPlan).filter((plan) => plan.code))
}

export function findCatalogPlan(plans = [], kindOrCode = '') {
  const needle = String(kindOrCode || '').toLowerCase()
  if (!needle) return null
  return plans.find((plan) => plan.kind === needle || plan.code === needle || plan.id === needle) || null
}
